const LearnAlphabet = () => {
  return <div>Alphabet</div>;
};

export default LearnAlphabet;
